import { BasicRequest } from "./basicRequest";

export class ResumeMoovInstanceRequest extends BasicRequest{
    public moovInstanceId!:number;

    constructor(){
        super();
    }
}